import {PAYMENT_METHODS,PAYMENT_METHODS_PATH,paymentMethodPath,paymentPageBreadcrumbs,type PaymentMethod} from '../src/payment-method-catalog';

export function PaymentMethodMark({method}:{method:PaymentMethod}){
  return <img className={`payment-method-mark payment-mark-${method.logo}`} src={`/assets/payments/${method.logo}.svg`} alt=""/>;
}
export function PaymentMethodList({methods}:{methods:readonly PaymentMethod[]}){
  return <ul className="payment-method-list">{methods.map(method=><li key={method.id}>
    <div className="payment-method-art"><PaymentMethodMark method={method}/></div>
    <h3><a href={paymentMethodPath(method)}>{method.name}</a></h3>
    <p>{method.ticker?`${method.ticker} · ${method.network}`:method.kind==='wallet'?'Digital wallet':'Credit and debit cards'}</p>
  </li>)}</ul>;
}
function PaymentBreadcrumb({path}:{path:string}){
  const items=paymentPageBreadcrumbs(path);
  return <nav className="payment-breadcrumb" aria-label="Breadcrumb"><ol>{items.map((item,index)=><li key={item.path}>
    {index===items.length-1?<span aria-current="page">{item.name}</span>:<a href={item.path}>{item.name}</a>}
  </li>)}</ol></nav>;
}
function StartLinks(){return <div className="marketing-actions"><a className="marketing-button" href="/register?next=%2Fsubscribe">Create account</a><a className="marketing-text-link" href="/billing">Usage &amp; Billing</a></div>;}

export function PaymentGuideContent({method}:{method:PaymentMethod}){
  const crypto=method.kind==='crypto';
  return <article className="marketing payment-method-page payment-guide" aria-labelledby="payment-guide-title">
    <PaymentBreadcrumb path={paymentMethodPath(method)}/>
    <header className="payment-guide-hero">
      <div className="payment-hero-art"><PaymentMethodMark method={method}/></div>
      <h1 id="payment-guide-title">Pay with {method.name}.</h1>
      <p className="payment-guide-lead">Pay for an AI subscription or buy credits for your work.</p>
      <StartLinks/>
    </header>
    <hr className="payment-guide-divider"/>
    <section className="payment-guide-section" aria-labelledby="payment-uses-title">
      <h2 id="payment-uses-title">What you can pay for</h2>
      <dl className="payment-use-list">
        <div><dt><a href="/pricing">AI subscriptions</a></dt><dd>Choose a plan for your AI team.</dd></div>
        <div><dt><a href="/billing">AI compute credits</a></dt><dd>Enter the amount you want to spend. Review the credits and tax before payment.</dd></div>
        <div><dt><a href="/domain-registry">Domain registration</a></dt><dd>Use your account credits to register a domain. Choose the name and term before you confirm.</dd></div>
      </dl>
    </section>
    <hr className="payment-guide-divider"/>
    <section className="payment-guide-section" aria-labelledby="payment-checkout-title">
      <h2 id="payment-checkout-title">How to pay</h2>
      <ol className="payment-steps">
        <li>Create an account, then choose a subscription or extra credits.</li>
        <li>Review the total and choose {method.name} from the methods offered at checkout.</li>
        <li>{crypto?'Send the invoice amount to its address before it expires. Wait for network confirmation.':method.kind==='wallet'?method.check:'Enter your card details and approve the payment.'}</li>
      </ol>
      {(crypto||method.kind==='card')&&<p className="payment-check-note">{method.check}</p>}
      {method.kind==='wallet'&&<p className="payment-check-note">{method.detail}</p>}
      {crypto&&<p>Network fees are separate. Subscription renewals need a new payment; your wallet is not charged automatically.</p>}
    </section>
    <hr className="payment-guide-divider"/>
    <footer className="payment-guide-account">
      <p>Manage your subscription in <a href="/billing">Usage &amp; Billing</a>. Download receipts from <a href="/account/invoices">Invoices</a>.</p>
      {crypto&&<p>For a missing or incorrect transfer, email <a href="mailto:support@eightbots.com">support@eightbots.com</a> with the invoice reference and transaction ID.</p>}
    </footer>
  </article>;
}
export function PaymentDirectoryContent({cryptoOnly=false}:{cryptoOnly?:boolean}){
  return <div className="marketing payment-method-page">
    <PaymentBreadcrumb path={`${PAYMENT_METHODS_PATH}${cryptoOnly?'/crypto':''}`}/>
    <header className="payment-directory-hero"><h1>{cryptoOnly?'Crypto payment methods':'Payment methods'}</h1><p className="payment-guide-lead">Pay for AI subscriptions and compute credits. Use account credits for domains.</p><StartLinks/></header>
    {!cryptoOnly&&<section className="payment-directory-section" aria-labelledby="payment-wallets-title"><h2 id="payment-wallets-title">Apple Pay and Google Pay</h2><PaymentMethodList methods={PAYMENT_METHODS.filter(item=>item.kind==='wallet')}/></section>}
    {!cryptoOnly&&<section className="payment-directory-section" aria-labelledby="payment-cards-title"><h2 id="payment-cards-title">Credit and debit cards</h2><PaymentMethodList methods={PAYMENT_METHODS.filter(item=>item.kind==='card')}/></section>}
    <section className="payment-directory-section" aria-labelledby="payment-crypto-title"><h2 id="payment-crypto-title">Crypto assets and networks</h2><p>Use the asset and network shown on your invoice.</p><PaymentMethodList methods={PAYMENT_METHODS.filter(item=>item.kind==='crypto')}/></section>
  </div>;
}
